import { render, staticRenderFns } from "./inputHtml.vue?vue&type=template&id=56a27d89"
import script from "./inputHtml.vue?vue&type=script&lang=js"
export * from "./inputHtml.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports